import e from "papaparse";
import r from "react";
/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

var _o = function o(e, r) {
  return _o = Object.setPrototypeOf || {
    __proto__: []
  } instanceof Array && function (e, r) {
    e.__proto__ = r;
  } || function (e, r) {
    for (var o in r) {
      Object.prototype.hasOwnProperty.call(r, o) && (e[o] = r[o]);
    }
  }, _o(e, r);
};

function t(e, r) {
  if ("function" != typeof r && null !== r) throw new TypeError("Class extends value " + String(r) + " is not a constructor or null");

  function t() {
    this.constructor = e;
  }

  _o(e, r), e.prototype = null === r ? Object.create(r) : (t.prototype = r.prototype, new t());
}

function n(e, r) {
  for (var o = 0, t = r.length, n = e.length; o < t; o++, n++) {
    e[n] = r[o];
  }

  return e;
}

function i(e) {
  var r = 1024,
      o = 1048576,
      t = 1073741824;

  if (e < o) {
    var n = Number((e / r).toFixed(0));
    return n <= 0 ? e + " B" : n + " KB";
  }

  return e < t ? (e / o).toFixed(0) + " MB" : e < 1099511627776 ? (e / t).toFixed(0) + " GB" : "";
}

function l(e, r) {
  var o = !1;
  "#" == e[0] && (e = e.slice(1), o = !0);
  var t = parseInt(e, 16),
      n = (t >> 16) + r;
  n > 255 ? n = 255 : n < 0 && (n = 0);
  var i = (t >> 8 & 255) + r;
  i > 255 ? i = 255 : i < 0 && (i = 0);
  var l = (255 & t) + r;
  return l > 255 ? l = 255 : l < 0 && (l = 0), (o ? "#" : "") + (l | i << 8 | n << 16).toString(16);
}

function a(e) {
  return r.createElement("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    width: "23",
    height: "23",
    viewBox: "0 0 512 512"
  }, r.createElement("path", {
    fill: e.color,
    d: "M504.1 256C504.1 119 393 7.9 256 7.9S7.9 119 7.9 256 119 504.1 256 504.1 504.1 393 504.1 256z"
  }), r.createElement("path", {
    fill: "#FFF",
    d: "M285 256l72.5-84.2c7.9-9.2 6.9-23-2.3-31-9.2-7.9-23-6.9-30.9 2.3L256 222.4l-68.2-79.2c-7.9-9.2-21.8-10.2-31-2.3-9.2 7.9-10.2 21.8-2.3 31L227 256l-72.5 84.2c-7.9 9.2-6.9 23 2.3 31 4.1 3.6 9.2 5.3 14.3 5.3 6.2 0 12.3-2.6 16.6-7.6l68.2-79.2 68.2 79.2c4.3 5 10.5 7.6 16.6 7.6 5.1 0 10.2-1.7 14.3-5.3 9.2-7.9 10.2-21.8 2.3-31L285 256z"
  }));
}

var s = {
  progressBar: {
    borderRadius: 3,
    boxShadow: "inset 0 1px 3px rgba(0, 0, 0, .2)",
    bottom: 14,
    position: "absolute",
    width: "80%"
  },
  buttonProgressBar: {
    position: "inherit",
    width: "100%"
  },
  progressBarFill: {
    backgroundColor: "#659cef",
    borderRadius: 3,
    height: 10,
    transition: "width 500ms ease-in-out"
  }
},
    d = function (e) {
  function o() {
    return null !== e && e.apply(this, arguments) || this;
  }

  return t(o, e), o.prototype.render = function () {
    var e = this.props,
        o = e.style,
        t = e.progressBar,
        n = e.displayProgressBarStatus,
        i = e.isButtonProgressBar;
    return r.createElement("div", {
      style: Object.assign({}, s.progressBar, i && s.buttonProgressBar)
    }, r.createElement("span", {
      style: Object.assign({}, s.progressBarFill, o, {
        width: "".concat(t, "%"),
        display: n
      })
    }));
  }, o;
}(r.Component),
    u = {
  dropArea: {
    alignItems: "center",
    borderStyle: "dashed",
    borderWidth: 2,
    borderRadius: 20,
    borderColor: "#CCC",
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
    padding: 20
  },
  dropAreaDefaultBorderColor: {
    borderColor: "#CCC"
  },
  inputFile: {
    display: "none"
  },
  highlight: {
    borderColor: "#686868"
  },
  unhighlight: {
    borderColor: "#CCC"
  },
  dropFile: {
    background: "linear-gradient(to bottom, #EEE, #DDD)",
    borderRadius: 20,
    display: "block",
    height: 120,
    width: 100,
    paddingLeft: 10,
    paddingRight: 10,
    position: "relative",
    zIndex: 10
  },
  column: {
    alignItems: "center",
    display: "flex",
    flexDirection: "column",
    justifyContent: "center"
  },
  fileSizeInfo: {
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    borderRadius: 3,
    lineHeight: 1,
    marginBottom: "0.5em",
    padding: "0 0.4em"
  },
  fileNameInfo: {
    backgroundColor: "rgba(255, 255, 255, 0.4)",
    borderRadius: 3,
    fontSize: 14,
    lineHeight: 1,
    padding: "0 0.4em"
  },
  defaultCursor: {
    cursor: "default"
  },
  pointerCursor: {
    cursor: "pointer"
  },
  dropFileRemoveButton: {
    height: 23,
    position: "absolute",
    right: 6,
    top: 6,
    width: 23
  }
},
    p = function (o) {
  function s() {
    var t,
        s,
        d,
        p,
        c,
        v,
        f,
        g,
        h,
        m = o.apply(this, arguments) || this;
    return m.inputFileRef = r.createRef(), m.dropAreaRef = r.createRef(), m.fileSizeInfoRef = r.createRef(), m.fileNameInfoRef = r.createRef(), m.REMOVE_ICON_COLOR = m.props.removeButtonColor || (null === (p = null === (d = null === (s = null === (t = m.props.style) || void 0 === t ? void 0 : t.dropArea) || void 0 === s ? void 0 : s.dropFile) || void 0 === d ? void 0 : d.removeButton) || void 0 === p ? void 0 : p.color) || (null === (f = null === (v = null === (c = m.props.style) || void 0 === c ? void 0 : c.dropFile) || void 0 === v ? void 0 : v.removeButton) || void 0 === f ? void 0 : f.color) || (null === (h = null === (g = m.props.style) || void 0 === g ? void 0 : g.removeButton) || void 0 === h ? void 0 : h.color) || "#A01919", m.REMOVE_ICON_COLOR_LIGHT = l(m.REMOVE_ICON_COLOR, 40), m.state = {
      dropAreaCustom: {},
      progressBar: 0,
      displayProgressBarStatus: "none",
      file: null,
      timeout: null,
      files: null,
      removeIconColor: m.REMOVE_ICON_COLOR,
      isCanceled: !1
    }, m.componentDidUpdate = function (e) {
      m.props.isReset !== e.isReset && m.removeFile();
    }, m.componentDidMount = function () {
      var e = m.dropAreaRef.current;

      if (e) {
        if (["dragenter", "dragover", "dragleave", "drop"].forEach(function (r) {
          e.addEventListener(r, m.preventDefaults, !1);
        }), !m.props.noDrag) {
          ["dragenter", "dragover"].forEach(function (r) {
            e.addEventListener(r, m.highlight, !1);
          }), e.addEventListener("dragleave", m.unhighlight, !1), e.addEventListener("drop", m.unhighlight, !1), e.addEventListener("drop", m.visibleProgressBar, !1), e.addEventListener("drop", m.handleDrop, !1);
        }
      }
    }, m.componentWillUnmount = function () {
      var e = m.dropAreaRef.current;

      if (["dragenter", "dragover", "dragleave", "drop"].forEach(function (r) {
        e.removeEventListener(r, m.preventDefaults, !1);
      }), !m.props.noDrag) {
        ["dragenter", "dragover"].forEach(function (r) {
          e.removeEventListener(r, m.highlight, !1);
        }), e.removeEventListener("dragleave", m.unhighlight, !1), e.removeEventListener("drop", m.unhighlight, !1), e.removeEventListener("drop", m.visibleProgressBar, !1), e.removeEventListener("drop", m.handleDrop, !1);
      }
    }, m.preventDefaults = function (e) {
      e.preventDefault(), e.stopPropagation();
    }, m.highlight = function () {
      var e,
          r,
          o,
          t,
          n = m.props.style;
      m.setState({
        dropAreaCustom: Object.assign({}, (null == n ? void 0 : n.dropAreaActive) ? (null == n ? void 0 : n.dropAreaActive.borderColor) ? null == n ? void 0 : n.dropAreaActive : Object.assign({}, null == n ? void 0 : n.dropAreaActive, u.highlight) : (null === (e = null == n ? void 0 : n.dropArea) || void 0 === e ? void 0 : e.dropAreaActive) ? (null === (r = null == n ? void 0 : n.dropArea) || void 0 === r ? void 0 : r.dropAreaActive.borderColor) ? null === (o = null == n ? void 0 : n.dropArea) || void 0 === o ? void 0 : o.dropAreaActive : Object.assign({}, null === (t = null == n ? void 0 : n.dropArea) || void 0 === t ? void 0 : t.dropAreaActive, u.highlight) : u.highlight)
      }), m.setState({
        progressBar: 0
      });
    }, m.unhighlight = function () {
      var e, r;
      m.setState({
        dropAreaCustom: Object.assign({}, (null === (r = null === (e = m.props.style) || void 0 === e ? void 0 : e.dropArea) || void 0 === r ? void 0 : r.borderColor) ? {} : u.dropAreaDefaultBorderColor)
      });
    }, m.visibleProgressBar = function () {
      m.props.noProgressBar || m.setState({
        displayProgressBarStatus: "block"
      });
    }, m.handleDrop = function (e) {
      var r = null,
          o = !1;
      void 0 === e.files ? r = e.dataTransfer.files : r = e.files;
      0 === r.length && (r = m.state.files, o = !0), m.setState({
        files: r,
        isCanceled: o
      }, function () {
        m.handleFiles();
      });
    }, m.handleFiles = function () {
      m.setState({
        progressBar: 0
      });
      n([], m.state.files).forEach(m.uploadFile);
    }, m.uploadFile = function (r) {
      m.displayFileInfo(r), m.setState({
        file: r
      });
      var o = m.props,
          t = o.onDrop,
          n = o.onFileLoad,
          i = o.onError,
          l = o.config,
          a = void 0 === l ? {} : l,
          s = new window.FileReader(),
          d = {},
          u = r.size,
          p = [],
          c = 0;

      if (t || n) {
        var v = m;
        d = Object.assign({
          complete: (null == a ? void 0 : a.complete) || (null == a ? void 0 : a.step) ? a.complete : function () {
            !t && n ? n(p, r) : t && !n && t(p, r);
          },
          step: (null == a ? void 0 : a.step) ? a.step : function (e) {
            if (p.push(e), a && a.preview) c = Math.round(p.length / a.preview * 100), v.setState({
              progressBar: c
            }), p.length === a.preview && (!t && n ? n(p, r) : t && !n && t(p, r));else {
              var o = e.meta.cursor,
                  i = Math.round(o / u * 100);
              if (i === c) return;
              c = i;
            }
            v.setState({
              progressBar: c
            });
          }
        }, d);
      }

      i && (d = Object.assign({
        error: i
      }, d)), a && (d = Object.assign({}, a, d)), s.onload = function (r) {
        e.parse(r.target.result, d);
      }, m.props.noProgressBar || (s.onloadend = function () {
        clearTimeout(m.state.timeout), m.setState({
          timeout: setTimeout(function () {
            m.disableProgressBar();
          }, 2e3)
        });
      }), s.readAsText(r, a.encoding || "utf-8");
    }, m.displayFileInfo = function (e) {
      m.childrenIsFunction() || (m.fileSizeInfoRef.current.innerHTML = i(e.size), m.fileNameInfoRef.current.innerHTML = e.name);
    }, m.disableProgressBar = function () {
      m.props.noProgressBar || m.setState({
        displayProgressBarStatus: "none"
      });
    }, m.childrenIsFunction = function () {
      return "function" == typeof m.props.children;
    }, m.fileChange = function (e) {
      var r = e.target;
      m.props.noProgressBar ? m.handleDrop(r) : m.setState({
        displayProgressBarStatus: "block"
      }, function () {
        m.handleDrop(r);
      });
    }, m.open = function (e) {
      var r = m.state.displayProgressBarStatus;
      e && "none" === r && (m.preventDefaults(e), m.inputFileRef.current.value = null, m.inputFileRef.current.click());
    }, m.renderChildren = function () {
      var e = m.props.children,
          r = m.state,
          o = r.file,
          t = r.progressBar;
      return m.childrenIsFunction() ? e({
        file: o,
        progressBar: t
      }) : e;
    }, m.handleRemoveFile = function (e) {
      e && (e.stopPropagation(), m.removeFile());
    }, m.removeFile = function () {
      m.setState({
        files: null,
        file: null
      });
      var e = m.props.onRemoveFile;
      e && e(null), m.inputFileRef.current.value = null;
    }, m.changeRemoveIconColor = function (e) {
      e && m.setState({
        removeIconColor: e
      });
    }, m.renderDropFileRemoveButton = function () {
      var e = m.props.addRemoveButton,
          o = m.state,
          t = o.removeIconColor,
          n = o.displayProgressBarStatus;
      return e && "none" === n ? r.createElement("div", {
        style: u.dropFileRemoveButton,
        onClick: function onClick(e) {
          return m.handleRemoveFile(e);
        },
        onMouseOver: function onMouseOver() {
          return m.changeRemoveIconColor(m.REMOVE_ICON_COLOR_LIGHT);
        },
        onMouseOut: function onMouseOut() {
          return m.changeRemoveIconColor(m.REMOVE_ICON_COLOR);
        }
      }, r.createElement(a, {
        color: t
      })) : e ? r.createElement("div", {
        style: u.dropFileRemoveButton
      }, r.createElement(a, {
        color: m.REMOVE_ICON_COLOR
      })) : null;
    }, m;
  }

  return t(s, o), s.prototype.render = function () {
    var e,
        o,
        t,
        n,
        i,
        l,
        a,
        s,
        p,
        c,
        v,
        f,
        g,
        h = this,
        m = this.props,
        C = m.style,
        B = m.noClick,
        b = m.children,
        E = m.noProgressBar,
        R = m.progressBarColor,
        y = m.accept,
        O = this.state,
        F = O.dropAreaCustom,
        A = O.files,
        S = O.isCanceled,
        I = O.progressBar,
        P = O.displayProgressBarStatus;
    return r.createElement(r.Fragment, null, r.createElement("input", {
      type: "file",
      accept: y || "text/csv, .csv, application/vnd.ms-excel",
      ref: this.inputFileRef,
      style: u.inputFile,
      onChange: function onChange(e) {
        return h.fileChange(e);
      }
    }), this.childrenIsFunction() ? r.createElement("div", {
      ref: this.dropAreaRef
    }, this.renderChildren(), A && A.length > 0 && !S && !E && r.createElement(d, {
      style: Object.assign({}, R ? {
        backgroundColor: R
      } : {}, (null === (f = null === (v = null == C ? void 0 : C.dropArea) || void 0 === v ? void 0 : v.dropFile) || void 0 === f ? void 0 : f.progressBar) || (null === (g = null == C ? void 0 : C.dropFile) || void 0 === g ? void 0 : g.progressBar) || (null == C ? void 0 : C.progressBar)),
      progressBar: I,
      displayProgressBarStatus: P,
      isButtonProgressBar: !0
    })) : r.createElement("div", {
      ref: this.dropAreaRef,
      style: Object.assign({}, u.dropArea, null == C ? void 0 : C.dropArea, F, void 0 !== B || "block" === P ? u.defaultCursor : u.pointerCursor),
      onClick: function onClick(e) {
        B || h.open(e);
      }
    }, A && A.length > 0 ? r.createElement("div", {
      style: Object.assign({}, u.dropFile, u.column, (null === (e = null == C ? void 0 : C.dropArea) || void 0 === e ? void 0 : e.dropFile) || (null == C ? void 0 : C.dropFile))
    }, this.renderDropFileRemoveButton(), r.createElement("div", {
      style: u.column
    }, r.createElement("span", {
      style: Object.assign({}, u.fileSizeInfo, (null === (t = null === (o = null == C ? void 0 : C.dropArea) || void 0 === o ? void 0 : o.dropFile) || void 0 === t ? void 0 : t.fileSizeInfo) || (null === (n = null == C ? void 0 : C.dropArea) || void 0 === n ? void 0 : n.fileSizeInfo) || (null == C ? void 0 : C.fileSizeInfo)),
      ref: this.fileSizeInfoRef
    }), r.createElement("span", {
      style: Object.assign({}, u.fileNameInfo, (null === (l = null === (i = null == C ? void 0 : C.dropArea) || void 0 === i ? void 0 : i.dropFile) || void 0 === l ? void 0 : l.fileNameInfo) || (null === (a = null == C ? void 0 : C.dropFile) || void 0 === a ? void 0 : a.fileNameInfo) || (null == C ? void 0 : C.fileNameInfo)),
      ref: this.fileNameInfoRef
    })), A && A.length > 0 && !S && !E && r.createElement(d, {
      style: Object.assign({}, R ? {
        backgroundColor: R
      } : {}, (null === (p = null === (s = null == C ? void 0 : C.dropArea) || void 0 === s ? void 0 : s.dropFile) || void 0 === p ? void 0 : p.progressBar) || (null === (c = null == C ? void 0 : C.dropFile) || void 0 === c ? void 0 : c.progressBar) || (null == C ? void 0 : C.progressBar)),
      progressBar: I,
      displayProgressBarStatus: P
    })) : b));
  }, s.defaultProps = {
    isReset: !1
  }, s;
}(r.Component),
    c = "link",
    v = "button",
    f = function (o) {
  function n() {
    var r = null !== o && o.apply(this, arguments) || this;
    return r.download = function (r, o, t, n) {
      var i = t ? "\uFEFF" : "",
          l = null,
          a = null;
      "function" == typeof r && (r = r()), l = "object" == typeof r ? e.unparse(r, n) : r;
      var s = new Blob(["".concat(i).concat(l)], {
        type: "text/csv;charset=utf-8;"
      }),
          d = window.navigator;
      a = d.msSaveBlob ? d.msSaveBlob(s, "".concat(o, ".csv")) : window.URL.createObjectURL(s);
      var u = document.createElement("a");
      u.href = a, u.setAttribute("download", "".concat(o, ".csv")), u.click(), u.remove();
    }, r;
  }

  return t(n, o), n.prototype.render = function () {
    var e = this,
        o = this.props,
        t = o.children,
        n = o.data,
        i = o.filename,
        l = o.type,
        a = o.className,
        s = o.style,
        d = o.bom,
        u = void 0 !== d && d,
        p = o.config,
        c = void 0 === p ? {} : p;
    return "link" === l ? r.createElement("a", {
      onClick: function onClick() {
        return e.download(n, i, u, c);
      },
      className: a,
      style: s
    }, t) : r.createElement("button", {
      onClick: function onClick() {
        return e.download(n, i, u, c);
      },
      className: a,
      style: s
    }, t);
  }, n.defaultProps = {
    type: "link"
  }, n;
}(r.Component);

function g(r, o) {
  return e.parse(r, o);
}

function h(r, o) {
  e.parse(r, Object.assign({}, {
    download: !0
  }, o));
}

function m(r, o) {
  return void 0 === o && (o = {}), e.unparse(r, o);
}

var C = e.BAD_DELIMITERS,
    B = e.RECORD_SEP,
    b = e.UNIT_SEP,
    E = e.WORKERS_SUPPORTED,
    R = e.LocalChunkSize,
    y = e.DefaultDelimiter;
export { C as BAD_DELIMITERS, v as BUTTON_TYPE, f as CSVDownloader, p as CSVReader, y as DefaultDelimiter, c as LINK_TYPE, R as LocalChunkSize, B as RECORD_SEP, b as UNIT_SEP, E as WORKERS_SUPPORTED, m as jsonToCSV, h as readRemoteFile, g as readString };